import { render, staticRenderFns } from "./tab-button.vue?vue&type=template&id=59702fc4&"
import script from "./tab-button.vue?vue&type=script&lang=js&"
export * from "./tab-button.vue?vue&type=script&lang=js&"
import style0 from "./tab-button.vue?vue&type=style&index=0&id=59702fc4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RzRadioGroupButton: require('/opt/airport.kg/node_modules/razlet-ui/src/components/radio-group-button/index.vue').default})
